import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import Box from '../Box';
import Input from '../Input/Input';
import InputBox from '../Input/InputBox';
import InputField from '../Input/InputField';
import NumberField from '../NumberField';
import { isIOS, noop, padNumber } from '../utils';
import { HOURS_TO_NOON, HOURS_IN_DAY, addHoursToTime, addMinutesToTime, addTimeToDate, getMeridiem, getTimeFromDate } from './utils';

var _ref = /*#__PURE__*/React.createElement(Box, {
  as: "span",
  width: 0.5,
  textAlign: "center",
  userSelect: "none"
}, ":");

var TimeField = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TimeField, _Component);

  function TimeField(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "setInputBoxRef", function (component) {
      _this.inputBox = component;
    });

    _defineProperty(_assertThisInitialized(_this), "updateTime", function (time) {
      if (time === void 0) {
        time = {};
      }

      var _this$props$value = _this.props.value,
          hours = _this$props$value[0],
          minutes = _this$props$value[1];

      if (time.hours !== undefined) {
        hours = time.hours;
      }

      if (time.minutes !== undefined) {
        minutes = time.minutes;
      }

      if (_this.props.twelveHourClock && !isIOS) {
        if (hours > 11 && _this.state.meridiem === 'AM') {
          hours -= 12;
        } else if (hours < 12 && _this.state.meridiem === 'PM') {
          hours += 12;
        }
      }

      _this.props.onChange([hours, minutes]);
    });

    _defineProperty(_assertThisInitialized(_this), "updateHours", function (amount) {
      _this.props.onChange(addHoursToTime(_this.props.value, amount));
    });

    _defineProperty(_assertThisInitialized(_this), "updateMinutes", function (amount) {
      _this.props.onChange(addMinutesToTime(_this.props.value, amount));
    });

    _defineProperty(_assertThisInitialized(_this), "toggleMeridiem", function () {
      _this.setState(function (state) {
        return {
          meridiem: state.meridiem === 'AM' ? 'PM' : 'AM'
        };
      }, _this.updateTime);
    });

    _defineProperty(_assertThisInitialized(_this), "handleHoursChange", function (hours) {
      _this.updateTime({
        hours: hours
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleHoursKeyDown", function (event) {
      if (event.key === 'ArrowRight') {
        _this.inputBox.focus(1);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMinutesChange", function (minutes) {
      _this.updateTime({
        minutes: minutes
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMinutesKeyDown", function (event) {
      if (event.key === 'ArrowLeft') {
        _this.inputBox.focus(0);
      }

      if (event.key === 'ArrowRight') {
        _this.inputBox.focus(2);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleAMPMKeyDown", function (event) {
      if (event.key !== 'Tab' && !(event.metaKey && event.key === 'r')) {
        event.preventDefault();
      }

      if (event.key === 'ArrowLeft') {
        _this.inputBox.focus(1);
      }

      if (event.key.toLowerCase() === 'a' && _this.state.meridiem === 'PM' || event.key.toLowerCase() === 'p' && _this.state.meridiem === 'AM' || event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        _this.toggleMeridiem();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleIOSChange", function (event) {
      var _event$target$value$s = event.target.value.split(':'),
          hours = _event$target$value$s[0],
          minutes = _event$target$value$s[1];

      _this.updateTime({
        hours: +hours,
        minutes: +minutes
      });
    });

    _this.state = {
      meridiem: getMeridiem(props.value)
    };
    return _this;
  }

  var _proto = TimeField.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(lastProps) {
    if (lastProps.value[0] !== this.props.value[0]) {
      this.setState({
        meridiem: getMeridiem(this.props.value)
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        value = _this$props.value,
        min = _this$props.min,
        max = _this$props.max,
        interval = _this$props.interval,
        onChange = _this$props.onChange,
        twelveHourClock = _this$props.twelveHourClock,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["value", "min", "max", "interval", "onChange", "twelveHourClock"]);

    var hours = value[0],
        minutes = value[1];
    return isIOS ? /*#__PURE__*/React.createElement(Input, _extends({}, restProps, {
      type: "time",
      autoWidth: hours + ":" + padNumber(minutes, 2) + " " + this.state.meridiem,
      value: padNumber(hours, 2) + ":" + padNumber(minutes, 2),
      onChange: this.handleIOSChange
    })) : /*#__PURE__*/React.createElement(InputBox, _extends({
      ref: this.setInputBoxRef,
      inline: true
    }, restProps), /*#__PURE__*/React.createElement(NumberField, {
      autoWidth: false,
      fontVariantNumeric: "tabular-nums",
      moveFocusOnMax: true,
      value: twelveHourClock ? hours % HOURS_TO_NOON || HOURS_TO_NOON : hours,
      min: twelveHourClock ? 1 : 0,
      max: twelveHourClock ? HOURS_TO_NOON : HOURS_IN_DAY - 1,
      pad: 2,
      grow: 0,
      width: "2ch",
      textAlign: "center",
      "aria-label": "Hours",
      onChange: this.handleHoursChange,
      onKeyDown: this.handleHoursKeyDown
    }), _ref, /*#__PURE__*/React.createElement(NumberField, {
      autoWidth: false,
      fontVariantNumeric: "tabular-nums",
      moveFocusOnMax: true,
      value: minutes,
      min: 0,
      max: 59,
      pad: 2,
      grow: 0,
      width: "2ch",
      textAlign: "center",
      "aria-label": "Minutes",
      onChange: this.handleMinutesChange,
      onKeyDown: this.handleMinutesKeyDown
    }), twelveHourClock && /*#__PURE__*/React.createElement(InputField, {
      highlightOnInteraction: true,
      value: this.state.meridiem,
      grow: 0,
      width: 3,
      textAlign: "center",
      "aria-label": "AM/PM",
      onChange: noop // prevent React warnings
      ,
      onKeyDown: this.handleAMPMKeyDown
    }));
  };

  return TimeField;
}(Component);

_defineProperty(TimeField, "addHoursToTime", addHoursToTime);

_defineProperty(TimeField, "addMinutesToTime", addMinutesToTime);

_defineProperty(TimeField, "addTimeToDate", addTimeToDate);

_defineProperty(TimeField, "getTimeFromDate", getTimeFromDate);

_defineProperty(TimeField, "defaultProps", {
  twelveHourClock: true
});

export default TimeField;